import { Component, OnInit,ViewChild ,ViewChildren,QueryList} from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { OrganismModel } from '../../organisms/organism.model';
import * as CommonConstants from '../../../utils/common.constants';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { PartnersService } from '../../partners.service';
import { AddDepartmentComponent } from 'src/app/masters/add-department/add-department.component';
import { AddAddressComponent } from 'src/app/masters/add-address/add-address.component';
import { AddContactComponent } from 'src/app/masters/add-contact/add-contact.component';
import { LoaderService } from 'src/app/common/loader.service';
import swal from 'sweetalert2';
import {CountryISO } from 'ngx-intl-tel-input';
import { IntlTelNumberComponent } from 'src/app/common/intl-tel-number/intl-tel-number.component';
@Component({
  selector: 'app-add-insurance',
  templateUrl: './add-insurance.component.html',
  styleUrls: ['./add-insurance.component.scss']
})
export class AddInsuranceComponent implements OnInit {
  insuranceForm: FormGroup;
  organisms: OrganismModel[];
  nationalities: any[];
  categories: any[];
  categoriesType: any[];
  agmntQuality: any[];
  certification: any[];
  partnerGroup: any[];
  legalFormList:any[];
  submitted = false;
  today = new Date();
  partnerId: number;
  addInsuranceTitle =true;
  editInsuranceTitle;
  partnerType: number = CommonConstants.PARTNER_INSURANCE_TYPE;
  countries:any;
  CountryISO = CountryISO;
  @ViewChild(AddDepartmentComponent, { static: true }) hospDepartment: AddDepartmentComponent;
  @ViewChild(AddAddressComponent, { static: true }) hospAddress: AddAddressComponent;
  @ViewChild(AddContactComponent, { static: true }) hospContact: AddContactComponent;
  @ViewChildren(IntlTelNumberComponent) phoneNos: QueryList<IntlTelNumberComponent>
  constructor(private masterService: MasterService, private formBuilder: FormBuilder, 
    private partnerService:PartnersService, private toasterService : ToastrService, private loaderService: LoaderService) {this.getFromGroup();  }

  ngOnInit() {
    this.loadMasterData();
  }
  loadMasterData() {
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getCategory().subscribe(response => {
      if (response && response['result']) {
        this.categories =response['result'].filter(category => category.partnerType == this.partnerType);
      }
    })
    this.masterService.getCategoryType().subscribe(response => {
      if (response && response['result']) {
        this.categoriesType  =response['result'].filter(type => type.partnerType == this.partnerType);
      }
    })
    this.masterService.getCertification().subscribe(response => {
      if (response && response['result']) {
        this.certification = response['result'];
      }
    })
    this.masterService.getAgmntQualtiy().subscribe(response => {
      if (response && response['result']) {
        this.agmntQuality = response['result'];
      }
    })
    this.masterService.getGroup().subscribe(response => {
      if (response && response['result']) {
        this.partnerGroup = response['result'];
      }
    })
    this.masterService.getLegalForm().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.legalFormList = response['result'];
      }
    });
    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];

      }
    })

  }
  get f() { return this.insuranceForm.controls; }

   /**
    * Declare form group
    *  
    */
   private getFromGroup() {
    this.insuranceForm = this.formBuilder.group({
      'insurId':[],
      'orgsmId': ['', Validators.required],
      'compaVaNameEn': ['', Validators.required],
      'pacatId': new FormControl(),
      'pctypId': new FormControl(),
      'compaVaWorkPhone': new FormControl(),
      'compaVaWorkFax': new FormControl(),
      'compaVaMobilePhone1': new FormControl(),
      'compaVaMobilePhone2': new FormControl(),
      'compaVaEmail': new FormControl(),
      'compaVaHomepage': new FormControl(),
      'leforId': new FormControl(),
      'compaNuNumberEmployees': new FormControl(),
      'agmntId': new FormControl(),
       'certiId': new FormControl(),
      'pagrpId': new FormControl(),
      'staRecCode': [true]
    })
  }
  save() {
    this.submitted = true;
    if (this.insuranceForm.invalid) {
      return;
    }
    this.insuranceForm.patchValue({ staRecCode: this.f.staRecCode.value ? 'A' : 'I'});
    let saveData = this.insuranceForm.value;
    this.phoneNos.forEach(phone => {
      saveData[phone.type]=phone.setPhoneNumberfrmInternation();
    })
    this.loaderService.display(true);
    this.partnerService.saveInsurance(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"]==0) {
        this.insuranceForm.patchValue({insurId: response['result']['insurId']});
        //this.toasterService.success(response['message'], 'Success');
        swal.fire("Success", response['message'], 'success');
      }else{
        //this.toasterService.error(response['message'], 'Error');
        swal.fire("Error", response['message'], 'error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  reset(){
    this.insuranceForm.reset();
  }
  onChangeOrganism(event){
    if(event && event.cotryId){
      let country  =this.countries.filter(type => type.cotryId == event.cotryId);
      this.phoneNos.forEach(phone => {
        phone.selectedCountry=country[0].cotryCode;
     })
    }else{
      this.phoneNos.forEach(phone => {
        phone.selectedCountry=CountryISO.France;
     })
    }
  }
}
